<script type="text/jsx">
import { mapGetters } from 'vuex';
import { getMessageStringByRules } from '@/views/config/partner-refer/helper/validator';
import { getPartnerImageFileInfo, replaceOfferDetailWithImageLink } from '@/views/config/partner-refer/helper/utils';

export default {
  name: 'PartnerOfferDetail',
  computed: {
    ...mapGetters(['partnerRefer']),
    // todo dynamic
    initOfferFeatureDetailContent() {
      const fileInfo = getPartnerImageFileInfo();
      const content = getMessageStringByRules(this.partnerRefer.initOfferFeatureDetailContent);
      const content1 = replaceOfferDetailWithImageLink(content, /\${offerDetailLogo}/g, fileInfo.offerDetailLogo);
      return replaceOfferDetailWithImageLink(content1, /\${offerPreloadFeature}/g, fileInfo.offerPreloadFeature);
    },
  },
  render() {
    return <div ref="wrapper" domPropsInnerHTML={this.initOfferFeatureDetailContent} />;
  },
  methods: {
    handlerCheckout(event) {
      const target = event.target;
      const classList = [...(target.classList ?? [])];

      if (classList.includes('opc-partner-perplexity__footer--checkout-btn')) {
        this.$emit('close');
      }
    }
  },
  mounted() {
    const wrapperDom = this.$refs.wrapper;
    wrapperDom && wrapperDom.addEventListener('click', this.handlerCheckout);
  },
  beforeDestroy() {
    const wrapperDom = this.$refs.wrapper;
    wrapperDom && wrapperDom.removeEventListener('click', this.handlerCheckout);
  }
};
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-partner-perplexity {
  &__wrapper {

  }

  &__header {
    text-align: center;
    margin-bottom: 16px;

    &--logo {
      width: 275px;
    }

    &--title {
      margin-top: 20px;
      font-family: $happy-display;
      font-size: 24px;
      font-weight: 400;
      line-height: 36px;
      text-align: center;
      padding: 0px 20px;
    }
  }

  &__body {
    display: flex;
    align-items: center;
    padding: 0px 12px;

    &--features {
      margin-right: 24px;
    }

    &--feature-item {
      display: flex;
      align-items: center;

      &:not(:nth-of-type(1)) {
        margin-top: 8px;
      }

      &:before {
        display: block;
        width: 16px;
        height: 14px;
        background: url("../../../../../assets/partner/perplexity/checked.svg");
        content: "";
        flex: 0 0 16px;
        margin-right: 8px;
      }

      margin-left: 8px;
      font-size: 14px;
      font-weight: 400;
      line-height: 16.8px;
      text-align: left;
    }

    &--feature-img {
      width: 280px;
      height: 176px;
    }
  }

  &__footer {
    padding-top: 28px;
    text-align: center;

    &--checkout-btn.zm-button--small.is-round {
      padding: 12px 90px;
      font-size: 16px;
      font-weight: 600;
      line-height: 19.2px;
      text-align: left;
    }
  }
}
</style>
